function format(string, ...args) {
  return string.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : '';
  });
}

export default {
  format,
};



// WEBPACK FOOTER //
// ./src/js/string-helper.js